// Shared value formatters used by both the desktop tables and the mobile UI.

/**
 * Rails serializes decimal columns as strings ("50.0"), so trim the
 * insignificant zeros before appending the unit.
 */
export function formatVolume(volume: number | string | null | undefined): string | null {
  if (volume === null || volume === undefined || volume === "") return null
  const parsed = typeof volume === "number" ? volume : parseFloat(volume)
  if (Number.isNaN(parsed)) return null
  return `${parsed.toLocaleString("pt-BR", { maximumFractionDigits: 2 })} L`
}
